// Module
var code = "<div class=\"widget-content trend-widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <wt-line-chart id=\"chart\" chart-data=\"vm.trend.data\" series=\"vm.trend.series\" options=\"vm.trend.options\"> </wt-line-chart> </div>";
// Exports
module.exports = code;